<template>
  <div class="menu-selecrt-wrapper">
    <a-auto-complete
      class="certain-category-search"
      dropdownClassName="menu-search-dropdown"
      :dropdownMatchSelectWidth="false"
      :dropdownStyle="{ width: '260px' }"
      style="width: 100%"
      placeholder="菜品名称"
      optionLabelProp="text"
      @search="handleSearch"
      @select="handleSelect"
      :defaultValue="defaultValue"
    >
      <template slot="dataSource">
        <a-select-option
          v-for="item in dataSource"
          :key="item.id.toString()"
          :text="item.name"
        >
          <div class="selectItem">
            <a-avatar
              slot="avatar"
              :size="48"
              shape="square"
              :src="item.imgUrl ? item.imgUrl : 'images/noImg.jpg'"
            />
            <div class="selectItem-text">
              <p>{{ item.name }}</p>
              <p>￥{{ item.defaultUnitPrice }}</p>
            </div>
          </div>
        </a-select-option>
      </template>
    </a-auto-complete>
  </div>
</template>
<script>
import { getMenuList } from '@/apis/publishMenu';

export default {
  data() {
    return {
      dataSource: [],
      prevTime: 0,
      selectedItem: []
    }
  },
  props: {
    defaultValue: {
      type: String,
      default: ''
    },
    publishMealType: Number
  },
  methods: {
    handleSearch(value) {
      let that = this

      if (new Date().getTime() - that.prevTime > 300) {
        that.prevTime = new Date().getTime()
        that.dataSource = []
        getMenuList({
          name: value,
          eatType: ''
        }).then(res => {
          const result = res.data.attribute
          const tempData = []

          result.packages.forEach(item => {
            if (item.menuEatType.split(',').includes(String(that.publishMealType))) {
              let itemImgUrl = ''
              for (let i = 0; i < item.menus.length; i++) {
                if (item.menus[i].imgUrl) {
                  itemImgUrl = item.menus[i].imgUrl
                  break
                }
              }
              tempData.push({
                id: item.id,
                code: item.codeNumber,
                name: item.name,
                menus: item.menus,
                isPackage: true,
                imgUrl: itemImgUrl,
                defaultUnitPrice: item.defaultPrice ? item.defaultPrice : '0'
              })
            }
          })

          result.menus.forEach(item => {
            tempData.push({
              id: item.id,
              name: item.name,
              isPackage: false,
              imgUrl: item.imgUrl,
              defaultUnitPrice: item.defaultUnitPrice
            })
          })
          that.dataSource = tempData
        })
      }
    },
    handleSelect(value, option) {
      this.selectedItem = this.getSelectObj(value)
      this.$emit('select', this.selectedItem)
    },
    getSelectObj(key) {
      let retObjIndex = this.dataSource.findIndex((item) => {
        return item.id.toString() === key
      })
      return this.dataSource[retObjIndex]
    }

  },
  created() {

  }
}
</script>
<style>
.menu-search-dropdown .ant-select-dropdown-menu-item {
  border-bottom: 1px solid #f6f6f6;
}

.menu-search-dropdown .ant-select-dropdown-menu {
  max-height: 300px;
}
</style>

<style lang="less" scoped>
.menu-selecrt-wrapper
  /deep/
  .certain-category-search.ant-select-auto-complete
  .ant-input-affix-wrapper
  .ant-input-suffix {
  right: 12px;
}
.menu-selecrt-wrapper /deep/ .certain-search-item-count {
  position: absolute;
  color: #999;
  right: 16px;
}
.menu-selecrt-wrapper
  /deep/
  .certain-category-search.ant-select-focused
  .certain-category-icon {
  color: #108ee9;
}
.menu-selecrt-wrapper /deep/ .certain-category-icon {
  color: #6e6e6e;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 16px;
}

/* 下拉 */
.selectItem {
  display: flex;

  .selectItem-text {
    padding-left: 20px;
    p {
      padding: 0;
      margin: 0;
      line-height: 24px;
    }
  }
}
</style>
